import { DoseMatrix } from '~/domain/patient/doseMatrix';

// A dose's own frame of reference; its set's image stands in only where the dose names none.
export function doseFrameOfReferenceUid(dose: DoseMatrix): string | undefined {
    return (
        dose.dicomDose.frameOfReferenceUid ||
        dose.structureSet?.image?.frameOfReferenceUid ||
        undefined
    );
}
